import { TOKEN_DATA_TYPE } from "enum/enums";
import { API_END_POINTS, ROUTES, SELECTED_TENANT } from "lib/Constants";
import React from "react";
import UseApiService from "services/apiService";
import styles from "./Tenants.module.scss";
import CustomButton from "atoms/customButton/CustomButton";
import NoDataPlaceHolder from "component/NoDataPlaceHolder";
import CustomDialog from "component/CustomDialog";
import RegisterTenants from "component/registerTenants/RegisterTenants";
import LoadingScreen from "component/LoadingScreen";
import { setLocalStorageData } from "lib/utils";
import organization from "services/organizationService";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store/store";
import { setSelectedTenant } from "store/auth/reducer";
import { Tenant } from "interface/interface";
import { HANDLE_AUTH } from "store/auth/action.types";

const Tenants = () => {
	const [tenants, setTenants] = React.useState<any[]>([]);
	const [showModal, setShowModal] = React.useState<boolean>(false);
	const { selectedTenant } = useSelector((state: RootState) => state.auth);
	const dispatch = useDispatch();
	const [loading, setLoading] = React.useState<boolean>(false);

	const navigate = useNavigate();
	const handleGetTenants = async () => {
		setLoading(true);
		try {
			const body = {
				url: API_END_POINTS.TENENTS.getList,
				headerToken: TOKEN_DATA_TYPE.ACCESS,
			};
			const res = await UseApiService().get(body);
			const uniqueTenants = [...new Map(res?.data.tenants.map((tenant: Tenant) => [tenant.tenantId, tenant])).values()];
			setTenants(uniqueTenants || []);
			if (uniqueTenants?.length === 1) {
				handleSelectedTenant(uniqueTenants[0],1)
				navigate(ROUTES.CUSTOMERS_LIST)
			}else if (!uniqueTenants.length) {
				dispatch({ type: HANDLE_AUTH })
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};
	const handleShowModal = () => {
		setShowModal(!showModal);
	};
	const getRegistered = async ({ tenantName, tenantEmail, orgName }: { tenantName: string; tenantEmail?: string; orgName: string }) => {
		try {
			const res: any = await organization.getRegistered({
				orgName: orgName,
				tenantAdminEmail: tenantEmail || "",
				tenantAdminName: tenantName,
			});
			console.log(res?.data, "register response");
			const organizations = [...tenants];
			organizations.push({ tenantId: res?.data?.tenantId, orgName: res?.data?.orgName });
			setTenants([...organizations]);
		} catch (error) {
			console.log(error);
			throw error;
		}
	};
	const handleSelectedTenant = (tenant:any,count=0) => {
		tenant ={...tenant,count}
		setLocalStorageData(SELECTED_TENANT,tenant );
		dispatch(setSelectedTenant(tenant));
	};
	React.useEffect(() => {
		handleGetTenants();
	}, []);


	return loading ? (
		<div className="flex-wrap align-center justify-center w-full h-full">
			<LoadingScreen height={false} customClass="h-full" />
		</div>
	) : (
		<>
 
			<div className={`${styles.main}`}>
				<div className={` ${styles.main__logo} flex-wrap gap-10 justify-end`}>
					{/* <h2>
						<span>Tenants</span>
					</h2> */}
					<CustomButton buttonText="Register" className="button" handleFunc={handleShowModal} />
				</div>
				{tenants?.length > 0 ? (
					<div className={`${styles.main__wrapper}`}>
						<div className={`${styles.main__wrapperBorder}`}>
							<div className={`${styles.main__list} flex-wrap`}>
								{tenants.map((tenant) => {
									const isSelected = String(selectedTenant?.tenantId || "").trim() === String(tenant?.tenantId || "").trim();

									return (
										<div
											className={`${styles.main__listItemBox} ${isSelected ? styles.active : ""}`}
											key={tenant?.tenantId}
											onClick={() => {
												handleSelectedTenant(tenant,tenants?.length)
											}}
										>
											<h2>{tenant?.orgName}</h2>
										</div>
									);
								})}
							</div>
						</div>
						<div className={`${styles.main__button} flex-wrap justify-end`}>
							<CustomButton disabled={!Object.keys(selectedTenant).length} buttonText={"Next"} className="button" handleFunc={() => navigate(ROUTES.CUSTOMERS_LIST)} />
						</div>
					</div>
				) : (
					<div className={`${styles.main__wrapper} flex-wrap align-center justify-center w-full h-full`}>
						<NoDataPlaceHolder message="No tenants found in this list" />
					</div>
				)}
			</div>
			<CustomDialog open={showModal} className="tenant-modal" handleShowModal={handleShowModal}>
				<RegisterTenants handleShowModal={handleShowModal} getRegistered={getRegistered} />
			</CustomDialog>
		</>
	);
};

export default Tenants;
